import { render, staticRenderFns } from "./RefundAfterSale.vue?vue&type=template&id=c0a15f06"
import script from "./RefundAfterSale.vue?vue&type=script&lang=js"
export * from "./RefundAfterSale.vue?vue&type=script&lang=js"
import style0 from "./RefundAfterSale.vue?vue&type=style&index=0&id=c0a15f06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports